var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":"","column":""}},[_c('h1',[_vm._v("400 - Something isn't right")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error))])])
}
var staticRenderFns = []

export { render, staticRenderFns }